import { render, staticRenderFns } from "./shopingTemplate.vue?vue&type=template&id=6e0b275b&scoped=true&"
import script from "./shopingTemplate.vue?vue&type=script&lang=js&"
export * from "./shopingTemplate.vue?vue&type=script&lang=js&"
import style1 from "./shopingTemplate.vue?vue&type=style&index=1&id=6e0b275b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b275b",
  null
  
)

export default component.exports